import { Snackbar, BlurEvent } from "@mcleod/components";
import { AutogenLayoutSalespersonReassignmentReport } from "./autogen/AutogenLayoutSalespersonReassignmentReport";

/**
 * Salesperson Reassignment Report - Web Implementation
 * PBI: 352235
 *
 * Identifies customers and prospects that may need salesperson reassignment based on performance metrics.
 * Features complex validation and dynamic UI behavior based on metric selection.
 */
export class SalespersonReassignmentReport extends AutogenLayoutSalespersonReassignmentReport {

    onLoad(): void {
        // Set default values
        this.textboxGroupBy.setSelectedItemFromValue("A");
        this.textboxSortBy.setSelectedItemFromValue("A");
        this.textboxSelectType.setSelectedItemFromValue("B");
        this.textboxDaysRemaining.text = "30";
        this.textboxMetricType.setSelectedItemFromValue("A");
    }

    /**
     * Handles changes to the metric type dropdown.
     * Shows/hides the percentage label based on whether the selected metric uses percentage.
     */
    comboFilter2Changed() {
        const selectedValue = this.textboxMetricType.text || '';
        const selectedDisplayValue = this.textboxMetricType.selectedItem?.displayValue || '';
        
        // Show percentage label if either the value or display value contains a '%'
        this.labelPercentage.visible = selectedValue.includes('%') || selectedDisplayValue.includes('%');
    }
}
